import axios from 'axios'
import {
  GeoLocation,
  LocationAPIResult,
  WeatherAPIResult,
  IWeatherDailyWeather
} from '../types'
import { settings } from '../settings/config'

const { blockConfig } = settings

// Get AWS environment to determine dev/prod API endpoint
const w = window as any
const env = w.mp_globals && w.mp_globals.env && w.mp_globals.env.environment
const apiLocationUrl =
  env === 'live' ? blockConfig.api.location.live : blockConfig.api.location.sandbox
const apiWeatherUrl =
  env === 'live' ? blockConfig.api.weatherCurrent.live : blockConfig.api.weatherCurrent.sandbox
const apiWeatherDailyUrl =
  env === 'live' ? blockConfig.api.weatherDaily.live : blockConfig.api.weatherDaily.sandbox

export const getApiLocation = async (geolocation: GeoLocation): Promise<LocationAPIResult> => {
  try {
    if (
      !geolocation ||
      typeof geolocation.latitude !== 'number' ||
      Number.isNaN(geolocation.latitude) ||
      typeof geolocation.longitude !== 'number' ||
      Number.isNaN(geolocation.longitude)
    ) {
      throw new Error(`Invalid geolocation: ${JSON.stringify(geolocation)}`)
    }
    const url = `${apiLocationUrl}${geolocation.latitude.toFixed(2)}/${geolocation.longitude.toFixed(2)}`

    return await axios.get(url, { transformResponse: d => d }).then(response => JSON.parse(response.data))
  } catch (e) {
    console.error('Unable to get location from API', e)
    throw e
  }
}

export const getApiWeather = async (locationId: string): Promise<WeatherAPIResult> => {
  try {
    const url = `${apiWeatherUrl}${locationId}`

    return await axios.get(url, { transformResponse: d => d }).then(response => JSON.parse(response.data))
  } catch (e) {
    throw e
  }
}

export const getApiWeatherDaily = async (
  locationId?: string
): Promise<IWeatherDailyWeather[]> => {
  try {
    const url = `${apiWeatherDailyUrl}${locationId}`

    return await axios
      .get(url, { transformResponse: d => d })
      .then(response => JSON.parse(response.data))
  } catch (e) {
    throw e
  }
}
